import { syncGlobalGarageIcon, syncGarageIcons } from './utils';

export class LocalStorageGarageProvider {
  isEmpty() {
    const garage = JSON.parse(localStorage.getItem('garage') || '[]');
    return garage.length === 0;
  }

  has(id) {
    const garage = JSON.parse(localStorage.getItem('garage') || '[]');
    return garage.includes(id);
  }

  reset() {
    localStorage.removeItem('garage');
    this.#sync();
  }

  remove(id) {
    id = parseInt(id);

    const jsGarage = JSON.parse(localStorage.getItem('garage') || '[]');
    localStorage.setItem('garage', JSON.stringify(jsGarage.filter((_id) => _id !== id)));
    this.#sync();
  }

  add(id) {
    id = parseInt(id);

    const jsGarage = JSON.parse(localStorage.getItem('garage') || '[]');
    if (!jsGarage.includes(id)) {
      jsGarage.push(id);
    }
    localStorage.setItem('garage', JSON.stringify(jsGarage));
    this.#sync();
  }

  #sync() {
    syncGlobalGarageIcon();
    syncGarageIcons();
  }
}
